var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card" }, [
    _c(
      "div",
      { staticClass: "card-header p-0", attrs: { id: "headingLegend" } },
      [
        _c(
          "a",
          {
            staticClass: "btn btn-block text-left p-3",
            attrs: {
              "data-toggle": "collapse",
              role: "button",
              href: "#collapseLegend",
              "aria-expanded": "false",
              "aria-controls": "collapseLegend",
            },
          },
          [
            _c("h6", { staticClass: "mb-0" }, [
              _vm._v(_vm._s(_vm.$t(`${_vm.modelTranslateID}.title`))),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "collapse",
        attrs: {
          id: "collapseLegend",
          "aria-labelledby": "headingLegend",
          "data-parent": "",
        },
      },
      [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "form-check city-form-check pl-0" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.legend_automatic,
                        expression: "form.legend_automatic",
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "",
                        expression: "''",
                      },
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      type: "checkbox",
                      id: `cb-status`,
                      name: `cb-status`,
                      disabled: _vm.readonlyForm,
                      "false-value": false,
                      "true-value": true,
                      "data-vv-scope": _vm.vScope,
                    },
                    domProps: {
                      checked: Array.isArray(_vm.form.legend_automatic)
                        ? _vm._i(_vm.form.legend_automatic, null) > -1
                        : _vm.form.legend_automatic,
                    },
                    on: {
                      input: _vm.onChangeLegendAutomatic,
                      change: function ($event) {
                        var $$a = _vm.form.legend_automatic,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.form,
                                "legend_automatic",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.form,
                                "legend_automatic",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.form, "legend_automatic", $$c)
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label h-auto",
                      attrs: { for: `cb-status` },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex flex-column align-items-start" },
                        [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(`${_vm.modelTranslateID}.automatic`)
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          !_vm.form.legend_automatic
            ? _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 mb-3" }, [
                  _c("h6", { staticClass: "font-weight-normal" }, [
                    _vm._v(_vm._s(_vm.$t(`${_vm.modelTranslateID}.image`))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "legend img-thumbnail" },
                    [
                      _c("UploadMultipleImage", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "",
                            expression: "''",
                          },
                        ],
                        attrs: {
                          disabled: _vm.readonlyForm,
                          name: "legends",
                          imageSize: "small",
                          imageClass: "background-auto",
                          direction: "horizontal",
                          maxImage: 1,
                          multiple: false,
                          noOverlay: true,
                          showImageLimitMessage: false,
                          "data-vv-scope": _vm.vScope,
                        },
                        model: {
                          value: _vm.legends,
                          callback: function ($$v) {
                            _vm.legends = $$v
                          },
                          expression: "legends",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }